/* eslint-disable no-restricted-syntax */
/* eslint-disable no-await-in-loop */
import React from 'react';

import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';

import { Link } from 'react-router';

import _ from 'lodash';
import * as moment from 'moment';

import { UserPerms, execute } from 'store/configureStore';

import FlatButton from 'material-ui/FlatButton';
import RaisedButton from 'material-ui/RaisedButton';
import SelectField from 'material-ui/SelectField';
import MenuItem from 'material-ui/MenuItem';

import UserSelector from 'components/Base/UserSelector';
import SalesOrder from './Order/SalesOrder';

import AnnotationsEditor from '../Vessel/Content/AnnotationsEditor';
import AnnotationsList from '../Vessel/Content/AnnotationsList';
import HtmlContent from '../HtmlContent';
import TextEditor from '../Vessel/Content/TextEditor';

import { getLetter } from 'sagas/letters';
import * as sagaAnnotations from 'sagas/annotations';
import * as sagaLetters from 'sagas/lettersNew';

import { removeLetter } from 'actions/letters';
import { postAnnotations, removeAnnotations } from 'actions/annotations';
import { removeGazetters, postGazetters } from 'actions/gazetters';
import { addVesselSale, removeLastVesselSale, postVesselSale, updateVesselSaleUser } from 'actions/vessels/sales';
import { addNotification } from 'actions/notifications/notifications';

import Attachments from '../Attachments';

import styles from 'styles';

import * as actionTypes from 'constants/ActionTypes';

import ErrorBoundary from '../Vessel/ErrorBoundary';
// import Trainings from '../Gazetter/Trainings';

import { saveRequestsDataCreated } from 'sagas/orders';
import FailedToSent from '../../common/FailedToSent';
import api from 'services';
import ToSpamButton from '../../common/ToSpamButton';

class VesselSales extends React.Component {
    constructor(props) {
        super(props);

        if (localStorage.getItem(`settings-sales-vessel${props.objUser.user._id}`)) {
            this.initialState = JSON.parse(localStorage.getItem(`settings-sales-vessel${props.objUser.user._id}`));
        } else {
            this.initialState = { annotationsServer: 'mailparse.net', clarifiedServer: 'standart' };
            localStorage.setItem(`settings-sales-vessel${props.objUser.user._id}`, JSON.stringify(this.initialState));
        }

        this.state = {
            ...this.initialState,
            textLetter: '',
            typeAnnotations: 'annotate',
            gazetters: [],
            filteredGazetters: [],
            annotations: [],
            updated: false,
            clientVessel: undefined,
            openedAttachmentsDialog: false,

            selectedServer: 'mailparse.net',
            failedToSentOpen: false,
            isFormChanged: false,
            vesselSalesDuplicates: [],
        };

        this.addSaleTable = this.addSaleTable.bind(this);
        this.sendRequestSale = this.sendRequestSale.bind(this);
        this.removeSaleTable = this.removeSaleTable.bind(this);
        this.changeAnnotationsServer = this.changeAnnotationsServer.bind(this);
        this.changeClarifiedServer = this.changeClarifiedServer.bind(this);
        this.clearSaleTable = this.clearSaleTable.bind(this);
        this.updatePostGazetters = this.updatePostGazetters.bind(this);
        this.getLetterData = this.getLetterData.bind(this);

        this.handleClientChange = this.handleClientChange.bind(this);
        this.saveRequestsDataCreated = this.saveRequestsDataCreated.bind(this);
    }

    async getLetterData(textEdit) {
        try {
            const { data: letter } = await execute(getLetter, this.props.routeParams.id, 'vessel');
            letter.gazettersArr = [];
            letter.type = 'vessel';
            if (textEdit) {
                letter.text = textEdit;
            }
            letter.fromVesselSales = true;
            const annotationsResponse = await execute(
                sagaAnnotations.postAnnotations, 
                letter.text, 
                letter.type, 
                this.state.annotationsServer, 
                { 
                    emailId: letter._id,
                    subject: letter.subject,
                    date: moment(letter.date).format('DD-MM-YYYY'),
                },
            );

            if (annotationsResponse) {
                letter.gazettersArr = annotationsResponse.data.annotations;
                if (annotationsResponse.data.newclarified) {
                    letter.newclarified = annotationsResponse.data.newclarified;
                }
            }
            
            await execute(sagaLetters.updateLetter, _.omit(letter, 'gazettersArr'), 'vessel', this.state.clarifiedServer);
        } catch (error) {
            addNotification({
                type: actionTypes.ADD_NOTIFICATION,
                notification: {
                    title: 'Error',
                    message: error.errors.messages[0],
                    level: 'error',
                    _id: new Date().getMilliseconds(),
                    autoDismiss: 10,
                },
            });
        }
    }

    changeAnnotationsServer(e, i, value) {
        this.initialState = {
            annotationsServer: value,
            clarifiedServer: this.state.clarifiedServer,
        };

        localStorage.setItem(`settings-sales-vessel${this.props.objUser.user._id}`, JSON.stringify(this.initialState));

        this.setState(this.initialState, () => { this.getLetterData(); });
    }

    changeClarifiedServer(e, i, value) {
        this.initialState = {
            annotationsServer: this.state.annotationsServer,
            clarifiedServer: value,
        };

        localStorage.setItem(`settings-sales-vessel${this.props.objUser.user._id}`, JSON.stringify(this.initialState));

        this.setState(this.initialState, () => { this.getLetterData(); });
    }

    UNSAFE_componentWillMount() {
        const { state } = this.props.location;
        if (state) {
            this.getLetterData(state.modifiedTextLetter);
        } else {
            this.getLetterData();
        }
    }

    changeServer(e, i, value) {
        this.setState({
            selectedServer: value,
        }, () => {
            this.getLetterData();
        });
    }

    createVesselSalesRequest(vesselSale, keyVesselSale, vesselSalesRequests) {
        const {
            _id, context: {
                kind, parser, companyId, userId, 
            }, realUserEmail, 
        } = this.props.letter;
        vesselSalesRequests.push({
            mailId: this.props.letter._id,
            ideaPrice: vesselSale.ideaPrice,
            salePrice: vesselSale.salePrice,
            vessel: vesselSale.vessel,
            context: {
                kind, 
                parser,
                companyId: companyId._id,
                userId: userId._id,
            },
            realUserEmail,
            keyVesselSale,
        });
    }

    async saveRequestsDataCreated(order) {
        try {
            await execute(saveRequestsDataCreated, 'sales', order);
        } catch (error) {
            console.error(error);
        }
    }

    sendRequestSale() {
        const vesselSales = _.cloneDeep(this.props.vesselSales);

        if (!vesselSales.length) {
            return;
        }

        this.setState({
            isFormChanged: false,
            vesselSalesDuplicates: _.cloneDeep(this.props.vesselSales),
        });

        const vesselSalesRequests = [];

        vesselSales.forEach((vesselSale, keyVesselSale) => {
            this.saveRequestsDataCreated(vesselSale);
            this.createVesselSalesRequest(vesselSale, keyVesselSale, vesselSalesRequests);
        });

        vesselSalesRequests.forEach((vesselSalesRequest) => {
            this.props.postVesselSale(vesselSalesRequest.vessel, vesselSalesRequest);
        });
    }

    removeSaleTable() {
        this.props.removeLastVesselSale();
    }

    clearSaleTable() {
        this.props.removeLastVesselSale();
        this.props.addVesselSale();
    }

    addSaleTable() {
        this.props.addVesselSale();
    }

    componentWillUnmount() {
        this.props.removeGazetters();
        this.props.removeAnnotations();
        this.props.removeLetter();
    }

    updatePostGazetters(textLetter) {
        this.setState({
            textLetter,
            gazetters: [],
            filteredGazetters: [],
            annotations: [],
            updated: true,
        }, async () => {
            await this.props.postGazetters(
                textLetter,
                { 
                    emailId: this.props.letter._id,
                    subject: this.props.letter.subject,
                    date: moment(this.props.letter.date).format('DD-MM-YYYY'),
                },
            );
        });
    }

    handleClientChange(e, i, value) {
        this.setState({ clientVessel: value });
    }

    toggleAttachmentsDialog = () => {
        this.setState({
            openedAttachmentsDialog: !this.state.openedAttachmentsDialog,
        });
    }

    toggleFailedToSentOpen = () => {
        this.setState({
            failedToSentOpen: !this.state.failedToSentOpen,
        });
    }

    UNSAFE_componentWillReceiveProps(nextProps) {
        if (!_.isEqual(nextProps.vesselSales, this.state.vesselSalesDuplicates)) {
            this.setState({ isFormChanged: true });
        } else {
            this.setState({ isFormChanged: false });
        }
    }

    sendRequestSaleFromSent = async (failedTwinLetterData) => {
        const vesselSales = _.cloneDeep(this.props.vesselSales);

        if (!vesselSales.length) {
            return;
        }

        const results = [];

        const vesselSalesRequests = [];

        vesselSales.forEach((vesselSale, keyVesselSale) => {
            vesselSalesRequests.push({
                mailId: failedTwinLetterData._id,
                ideaPrice: vesselSale.ideaPrice,
                salePrice: vesselSale.salePrice,
                vessel: vesselSale.vessel,
                context: failedTwinLetterData.context,
                realUserEmail: failedTwinLetterData.realUserEmail,
                keyVesselSale,
            });
        });

        for (const vesselSalesRequest of vesselSalesRequests) {
            const response = await api.postVesselSale(vesselSalesRequest.vessel, vesselSalesRequest);

            if (response.status === 200) {
                results.push({
                    ...response.data,
                    status: 'success',
                });
                await api.sendRefNumber(failedTwinLetterData._id, {
                    refNo: response.data.refNo, 
                    requestId: response.data.id || response.data._id,
                });
                this.saveRequestsDataCreated(vesselSalesRequest);
            } else if (response.status === 409) {
                results.push({
                    status: 'success',
                    ..._.get(response, 'errors[0].messages[1]'),
                });
                await api.sendRefNumber(failedTwinLetterData._id, {
                    refNo: _.get(response, 'errors[0].messages[1]').refNo, 
                    requestId: _.get(response, 'errors[0].messages[1]')._id,
                });
            } else {
                results.push({
                    status: 'error',
                    message: _.get(response, 'errors[0].messages[0]'),
                });
            }
        }

        return results;
    }

    render() {
        const {
            annotationsServer, clarifiedServer, textLetter, updated, clientVessel, openedAttachmentsDialog,
            failedToSentOpen,
        } = this.state;
        const {
            routeParams, letter, router, vesselSales, user, location, 
        } = this.props;
        
        let modifiedTextLetter;
        let initialTextLetter;

        if (location.state) {
            modifiedTextLetter = location.state.modifiedTextLetter;
            initialTextLetter = location.state.initialTextLetter;
        }

        return (
            <div id='single-letter-cargo' className='single-letter'>
                <div className='content'>
                    <div className='management'>
                        <div className='management-children'>
                            <RaisedButton
                                label='Gazetteer'
                                containerElement={<Link to={`/${routeParams.id}`} />}
                                primary
                                className="btn"
                                labelStyle={{ fontSize: '10px' }}
                                style={{ height: '25px', margin: '10px 10px 10px 0' }}
                                buttonStyle={{ height: '25px', lineHeight: '25px' }}
                            />
                            <ErrorBoundary>
                                <HtmlContent
                                    letter={letter}
                                />
                            </ErrorBoundary>

                            <TextEditor 
                                textLetter={modifiedTextLetter || textLetter || letter.text}
                                originalText={initialTextLetter || letter.text}
                                removeGazetters={this.props.removeGazetters}
                                removeAnnotations={this.props.removeAnnotations}
                                getLetterData={this.getLetterData}
                                updatePostGazetters={this.updatePostGazetters}
                            />

                            <Attachments 
                                openedAttachmentsDialog={openedAttachmentsDialog}
                                toggleAttachmentsDialog={this.toggleAttachmentsDialog}
                                labelStyle={{ fontSize: '10px' }}
                                style={{ height: '25px', margin: '10px 10px 10px -10px' }}
                                buttonStyle={{ height: '25px', lineHeight: '25px' }}
                                className='btn'
                                attachments={letter.attachments}
                            />

                            <RaisedButton 
                                className='btn'
                                labelStyle={{ fontSize: '10px' }}
                                style={{ height: '25px', margin: '10px 10px 10px 0' }}
                                buttonStyle={{ height: '25px', lineHeight: '25px' }}
                                label='Size'
                                containerElement={<Link to={`/${routeParams.id}/size/vessel`} />}
                                primary
                            />

                            {
                                UserPerms.isAdmin() ?
                                    <React.Fragment>
                                        <SelectField
                                            floatingLabelText='Annotations server'
                                            className='btn'
                                            value={annotationsServer}
                                            onChange={this.changeAnnotationsServer}
                                            style={{ width: '155px' }}
                                        >
                                            <MenuItem value='mailparse.net' primaryText='mailparse.net' />
                                            <MenuItem value='s4.anotatr.com' primaryText='s4.anotatr.com' />
                                            <MenuItem value='nata.im' primaryText='nata.im' />
                                            <MenuItem value='localhost' primaryText='localhost' />
                                        </SelectField>

                                        <SelectField
                                            floatingLabelText='Clarified server'
                                            className='btn'
                                            value={clarifiedServer}
                                            onChange={this.changeClarifiedServer}
                                            style={{ width: '110px' }}
                                            autoWidth
                                        >
                                            <MenuItem value='standart' primaryText='api' />
                                            <MenuItem value='localhost:7775' primaryText='localhost' />
                                            <MenuItem value='s4.anotatr.com:7777' primaryText='s4.anotatr.com' />
                                        </SelectField>
                                    </React.Fragment>
                                    :
                                    ''
                            }
                            <br />
                            {/* <Trainings letter={this.props.letter} /> */}
                            <ToSpamButton
                                letterId={letter._id}
                                onSuccess={() => {
                                    this.getLetterData();
                                }}
                                disabled={letter.type === 'spam'}
                            />
                            <FailedToSent
                                open={failedToSentOpen}
                                failedTwinsList={letter.failedTwinsByTextHash || []}
                                handleToggleDialog={this.toggleFailedToSentOpen}
                                disabled={this.state.isFormChanged}
                                sendRequest={this.sendRequestSaleFromSent}
                            />
                        </div>
                        <div className='subject' style={{ width: '150px' }}>SUBJECT: {letter.subject}</div>
                        <div className='subject'>refNo: {letter.refNo}</div>
                        
                    </div>
                    {
                        updated ?
                            (
                                <ErrorBoundary>
                                    <AnnotationsEditor letterText={textLetter || letter.text} />
                                </ErrorBoundary>
                            )
                            :
                            (
                                <ErrorBoundary>
                                    <AnnotationsEditor letterText={modifiedTextLetter || letter.text} />
                                </ErrorBoundary>
                            )
                    }

                    <ErrorBoundary>
                        <AnnotationsList />
                    </ErrorBoundary>
                </div>
                <div className='sidebar'>
                    <h1>Vessel  sales {vesselSales.length}</h1>

                    <ErrorBoundary>
                        {
                            vesselSales.map((vesselSale, key) => (<SalesOrder
                                numberSaleTable={key}
                                key={key}
                            />))
                        }
                    </ErrorBoundary>

                    <UserSelector 
                        handleClientChange={this.handleClientChange}
                        client={clientVessel}
                        user={user}
                        letter={letter}
                        errorUser={vesselSales[0] && vesselSales[0].validateErrors.find(v => v.field === 'user')}
                        onUserUpdate={this.props.updateVesselSaleUser}
                    />

                    <ul className='controller-orders'>
                        <li>
                            <FlatButton style={styles.btnOrders} onClick={this.addSaleTable} label='Add' />
                        </li>
                        <li>
                            <FlatButton style={styles.btnOrders} onClick={this.removeSaleTable} label='Remove' />
                        </li>
                        <li>
                            <FlatButton style={styles.btnOrders} onClick={this.clearSaleTable} label='Clear' />
                        </li>
                        <li>
                            <FlatButton style={styles.btnOrders} onClick={this.sendRequestSale} label='Send' />
                        </li>
                    </ul>
                </div>
            </div>
        );
    }
}

export default connect(
    state => ({
        objUser: state.user,
        user: state.vesselSales.user,
        vesselSales: state.vesselSales.items,
        isLogged: state.user.isLogged,
        letter: state.letter,
        annotations: state.annotations.items,
    }),
    dispatch => bindActionCreators({
        updateVesselSaleUser,
        postAnnotations,
        postGazetters,
        addVesselSale,
        removeLastVesselSale,
        postVesselSale,
        removeGazetters,
        removeAnnotations,
        removeLetter,
    }, dispatch),
)(VesselSales);



// WEBPACK FOOTER //
// ./app/components/Letters/Single/Sales/Page.jsx